export const DEFAULT_MAP_ZOOM = 4;
export const DEFAULT_MARKER_ZOOM = 15;
export const DEFAULT_GESTURE_HANDLING = 'cooperative';
export const DEFAULT_CANADA_LAT_LNG = { lat: 59.948213346543135, lng: -98.23089510250453 };
export const MARKER_SCALE = 1.1;
export const SELECTED_MARKER_SCALE = 1.2;
export const GEOCODING_LIB = 'geocoding';
export const ID = 'locations-map';
